/* global webapis */
var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.SamsungAvplay = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    var ret = 0
    try {
      if (typeof webapis !== 'undefined' && webapis.avplay && typeof webapis.avplay.getCurrentTime === 'function') {
        ret = webapis.avplay.getCurrentTime() / 1000
      }
    } catch (e) {
      // ret = 0
    }
    return ret
  },

  /** Override to return video duration */
  getDuration: function () {
    var ret = null
    if (!this.plugin.getIsLive()) {
      try {
        if (typeof webapis !== 'undefined' && webapis.avplay && typeof webapis.avplay.getDuration === 'function') {
          ret = webapis.avplay.getDuration() / 1000
        }
      } catch (e) {
        // ret = null
      }
    }
    return ret
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var ret = null
    try {
      if (typeof webapis !== 'undefined' && webapis.avplay && typeof webapis.avplay.getCurrentStreamInfo === 'function' &&
       webapis.avplay.getCurrentStreamInfo() && webapis.avplay.getCurrentStreamInfo()[0]) {
        var j = JSON.parse(webapis.avplay.getCurrentStreamInfo()[0].extra_info)
        var bitrate = (j.Bit_rate && j.Bit_rate !== '0') ? j.Bit_rate : -1
        if (bitrate < 2.5 * 1e4) {
          bitrate *= 100 // lower than 25k, for example: 22,000 -> 22,000,000 (it wont be less than 25kbps)
        } else if (bitrate > 2.5 * 1e7) {
          bitrate /= 100 // higher than 25M, for example: 35,000,000 -> 35,000 (it wont be more than 25Mbps)
        }
        ret = bitrate
      }
    } catch (e) {
      // ret = null
    }
    return ret
  },

  /** Override to return rendition */
  getRendition: function () {
    var ret = null
    try {
      if (typeof webapis !== 'undefined' && webapis.avplay && typeof webapis.avplay.getCurrentStreamInfo === 'function' &&
       webapis.avplay.getCurrentStreamInfo() && webapis.avplay.getCurrentStreamInfo()[0]) {
        var bitrate = this.getBitrate()
        var j = JSON.parse(webapis.avplay.getCurrentStreamInfo()[0].extra_info) || {}
        if (bitrate) {
          ret = youbora.Util.buildRenditionString(j.Width, j.Height, bitrate)
        }
      }
    } catch (e) {
      // ret = null
    }
    return ret
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    var ret = null
    try {
      if (typeof webapis !== 'undefined' && webapis.avplay && typeof webapis.avplay.getVersion === 'function') {
        ret = webapis.avplay.getVersion()
      }
    } catch (e) {
      // ret = null
    }
    return ret
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'AVPlay'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()
  },

  onbufferingcomplete: function () {
    // youbora.log.debug("onbufferingcomplete")
  },

  oncurrentplaytime: function () {
    // youbora.log.debug("oncurrentplaytime")
    if (!this.flags.isStarted) {
      this.fireStart()
      this.initialPlayhead = this.getPlayhead()
    }
    if (this.getIsLive() || this.getPlayhead() > 1 + this.initialPlayhead) {
      this.fireJoin()
    }
  },
  onerror: function (eventType) {
    // youbora.log.debug("onerror")
    this.fireError(eventType)
    this.fireStop()
  },
  onstreamcompleted: function () {
    // youbora.log.debug("onstreamcompleted")
    this.fireStop()
  },
  playVideo: function () {
    // youbora.log.debug("playVideo")
    this.fireResume()
  },
  pauseVideo: function () {
    // youbora.log.debug("pauseVideo")
    this.firePause()
  },
  stopVideo: function () {
    // youbora.log.debug("stopVideo")
    this.fireStop()
  },
  jumpForwardVideo: function () {
    // youbora.log.debug("jumpForwardVideo")
    if (!this.flags.isBuffering) {
      this.fireSeekBegin()
    }
  },
  jumpBackwardVideo: function () {
    // youbora.log.debug("jumpBackwardVideo")
    if (!this.flags.isBuffering) {
      this.fireSeekBegin()
    }
  }
})

module.exports = youbora.adapters.SamsungAvplay
